module.exports = __webpack_public_path__ + "img/client_add.153e6a79.svg";